import { CorporateProgramEntity } from '@/modules/programs/domain/entities/CorporateProgramEntity';
import {
  Block,
  BlockFormats,
  ContentTypes,
  DisplaySizes,
  DomainTypes,
  Selection,
  Typology,
} from '@/types';
import { CorporateHomepage, Homepage } from '@/types/homepage';

import { BlockEntity } from './BlockEntity';
import { HomePageEntity } from './HomePageEntity';

export class CorporateHomePageEntity {
  source: DomainTypes;
  domain: string;
  uuid: string;
  name: string;
  createdAt: number;
  updateAt: number;
  isDefault: boolean;
  selectionsCount: number;
  selections: Selection[];

  constructor(corporateHomePage: CorporateHomepage) {
    this.source = this.source || DomainTypes.Corporate;
    this.domain = corporateHomePage.domain;
    this.uuid = corporateHomePage.uuid;
    this.name = corporateHomePage.name;
    this.createdAt = corporateHomePage.createdAt || Date.now();
    this.updateAt = corporateHomePage.updateAt || Date.now();
    this.isDefault = corporateHomePage.isDefault;
    this.selectionsCount = corporateHomePage.selectionsCount || 0;
    this.selections = corporateHomePage.selections || [];
  }

  toHomepage(): Homepage {
    return new HomePageEntity({
      source: this.source,
      domain: this.domain,
      UUID: this.uuid,
      updateAt: this.updateAt,
      title: this.name,
      blocks: (this.selections || []).sort((a, b) => a.order - b.order).map((s) => this.toBlock(s)),
      isDefault: this.isDefault,
    });
  }

  toBlock(selection: Selection): Block {
    return new BlockEntity({
      UUID: selection.selection.uuid,
      contentType: ContentTypes.Program,
      format: this.toFormat(selection.displaySize),
      items: (selection.selection.programs || [])
        .sort((a, b) => a.order - b.order)
        .map((item) => new CorporateProgramEntity(item.program).toProgram()),
      populated: true,
      /** @todo: randomOrder is always 0 / falsy */
      randomOrder: 0,
      title: selection.selection.name,
      type: Typology.Editorial,
    });
  }

  toFormat(displaySize: DisplaySizes): BlockFormats {
    switch (displaySize) {
      case DisplaySizes.Header:
        return BlockFormats.HeaderCarousel;
      case DisplaySizes.Portrait:
      case DisplaySizes.Landscape:
        return BlockFormats.HighCarousel;
      default:
        return BlockFormats.Progress;
    }
  }
}
